const labels = [{
    name: 'Name',
    value: 'name'
},{
    name: 'Email ID',
    value: 'emailID'
},{
    name: 'College Name',
    value: 'collegeName'
},{
    name: 'MA_ID',
    value: 'id'
},{
    name: 'Gender',
    value: 'gender'
},{
    name: 'Bachelor Degree',
    value: 'bachelorDegree'
},{
    name: 'Bachelor Specialisation',
    value: 'bachelorSpecialisation'
},{
    name: 'Bachelor Semester',
    value: 'bachelorSemester'
},{
    name: 'Bachelor Aggregate',
    value: 'bachelorAggregate'
},{
    name: 'Master Degree',
    value: 'masterDegree'
},{
    name: 'Master Specialisation',
    value: 'masterSpecialisation'
},{
    name: 'Master Semester',
    value: 'masterSemester'
},{
    name: 'Master Aggregate',
    value: 'masterAggregate'
},{
    name: 'Placement Status',
    value: 'placementStatus'
},{
    name: 'Backlogs',
    value: 'backlogs'
},{
    name: 'Mobile No',
    value: 'mobileNo'
},{
    name: 'Current Address',
    value: 'currentAddress'
},{
    name: 'Permanent Address',
    value: 'permanentAddress'
},{
    name: 'Passport Available Status',
    value: 'passportAvailableStatus'
},{
    name: 'Willing To Travel Status',
    value: 'willingToTravelStatus'
},{
    name: 'Time of Registration',
    value: 'timestamp'
}];


  const csvConverter = (JSONData, fileName = 'Registrations') => {
    const arrData =
      typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
    let csv = '';
    let row = '';
    labels.forEach((fieldName) => {
      row += `${fieldName.name},`;
    });
    row = row.slice(0, -1);
    csv += `${row}\r\n`;
    for (let i = 0; i < arrData.length; i += 1) {
      row = '';
      const arrRow = arrData[i];
      // eslint-disable-next-line
      labels.forEach(fieldName => {
        const { value } = fieldName;
  
        if (value === 'index') {
          row += `${i + 1},`;
        } else {
          const arrValue =
            typeof arrRow[value] === 'undefined' ? '' : `"${stringFormatter(arrRow[value])}"`;
          row += `${arrValue},`;
        }
      });
      row.slice(0, row.length - 1);
      csv += `${row}\r\n`;
    }
  
    if (csv === '') {
      return;
    }
  
    const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
    const link = document.createElement('a');
    link.href = uri;
    link.style = 'visibility:hidden';
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const stringFormatter = str => typeof str === 'string' 
                                    ? str.replace(/\"/g,'\'')
                                    : str;
  export default csvConverter;
  


// WEBPACK FOOTER //
// ./src/utils/CampaignCSV.js